import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { createPortal } from 'react-dom';
import { getVideoManagementEmbedBaseUrl } from '../utils/urls';
import { useFramePortalContainer } from '../hooks/useFramePortalContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const frameName = 'video-panel-iframe';
export const VideoManagementIframe = ({
  style,
  isActive,
  rootNode,
  isLoading
}) => {
  const portalContainerRef = useFramePortalContainer(rootNode);
  const iframeContent =
  /*#__PURE__*/
  // @bend-expect trellis-tokenized
  _jsxs("div", {
    "data-test-id": "video-management-iframe-wrapper",
    style: Object.assign({
      display: isActive ? 'block' : 'none',
      position: 'fixed',
      top: 0,
      right: 0,
      width: '100%',
      height: '100%',
      zIndex: 11112,
      border: 'none'
    }, style),
    children: [isLoading && /*#__PURE__*/_jsx(LoadingOverlay, {
      size: "medium"
    }), /*#__PURE__*/_jsx("iframe", {
      name: frameName,
      height: "100%",
      width: "100%",
      style: {
        width: '100%',
        height: '100%',
        border: 'none'
      },
      src: getVideoManagementEmbedBaseUrl()
    })]
  });

  // Portal render into body-attached div
  // eslint-disable-next-line react-hooks/refs
  return portalContainerRef.current ?
  /*#__PURE__*/
  // eslint-disable-next-line react-hooks/refs
  createPortal(iframeContent, portalContainerRef.current) : null;
};